/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type ContentLocaleEnum = typeof ContentLocaleEnum[keyof typeof ContentLocaleEnum];


export const ContentLocaleEnum = {
  DE: 'de',
  EN: 'en',
  FR: 'fr',
  ES: 'es',
  NL: 'nl',
} as const;
